import styles from '../TopUpStatusAlertBox.module.css';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import messages from '../../../OutstandingView/dashboardActions/TopUpApproved/TopUpApproved.messages';
import { Rate } from '../../../../../myAccount/ui/rate';

export const TopUpApprovedAlert = ({
    approvalAmount,
    timeoutDate,
    interestRate
}: {
    approvalAmount: number;
    timeoutDate: string;
    interestRate: number;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="success"
            iconName="rocket"
            className={styles.approvedAlert}
            description={
                <>
                    <strong>
                        <FormattedMessage {...messages.title} />
                    </strong>{' '}
                    <FormattedMessage
                        {...messages.description}
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency value={approvalAmount} />
                                </strong>
                            ),
                            interestRate: (
                                <strong>
                                    <Rate value={interestRate} />
                                </strong>
                            ),
                            expiryDate: (
                                <strong>
                                    <FormattedDate
                                        value={timeoutDate}
                                        day="2-digit"
                                        month="short"
                                        year="numeric"
                                    />
                                </strong>
                            )
                        }}
                    />
                </>
            }
        />
    );
};
